import { render, staticRenderFns } from "./double-image.vue?vue&type=template&id=1704480f&scoped=true"
import script from "./double-image.vue?vue&type=script&lang=js"
export * from "./double-image.vue?vue&type=script&lang=js"
import style0 from "./double-image.vue?vue&type=style&index=0&id=1704480f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1704480f",
  null
  
)

export default component.exports